// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal_wrapper__aQdgs {
  width: 560px;
  height: 625px;
  padding: 20px; }

.modal_modal__ZEfWJ {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column; }
  .modal_modal__header__r97wE {
    display: flex;
    justify-content: space-between;
    align-items: center; }
    .modal_modal__header__r97wE h2 {
      font-weight: 600;
      font-size: 24px;
      line-height: 150%; }
    .modal_modal__header_close__U2PK2 {
      cursor: pointer;
      transition: all 0.4s; }
      .modal_modal__header_close__U2PK2:hover {
        transform: scale(1.1); }
  .modal_modal__ZEfWJ label {
    margin-top: 30px;
    display: flex;
    align-items: center; }
  .modal_modal__ZEfWJ .modal_buttons__ibt4H {
    position: absolute;
    bottom: 20px;
    right: 20px;
    display: flex;
    gap: 10px; }
  .modal_modal__ZEfWJ .modal_cancel__pweVF {
    background-color: #ffffff;
    color: #fe6100; }
    .modal_modal__ZEfWJ .modal_cancel__pweVF:hover {
      background-color: #fe6100;
      color: #ffffff; }
  .modal_modal__ZEfWJ .modal_checkbox__mbFyT {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 16px 0 16px;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    min-width: 20px;
    width: 20px;
    height: 20px;
    background: white;
    border: 1.5px solid #666666;
    border-radius: 3px;
    padding: 0;
    cursor: pointer; }
    .modal_modal__ZEfWJ .modal_checkbox__mbFyT:before {
      content: '';
      color: white;
      font-weight: bold;
      display: flex;
      width: 13px;
      height: 6px;
      margin-bottom: 5px;
      border-right: 1.5px solid white;
      border-top: 1.5px solid white;
      transform: rotate(135deg); }
    .modal_modal__ZEfWJ .modal_checkbox__mbFyT:checked {
      background: #fe6100;
      border: 1.5px solid #fe6100; }
  .modal_modal__input__\\+2Opk {
    position: relative;
    width: 100%;
    padding: 8px 12px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    border: 1px solid #9e9e9e;
    border-radius: 4px;
    display: flex;
    margin-top: 6px; }
    .modal_modal__input__\\+2Opk:focus {
      border-color: #212121;
      outline: none; }
`, "",{"version":3,"sources":["webpack://./src/pages/notificationEmail/components/modal.module.scss"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,aAAa,EAAA;;AAEf;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB,EAAA;EACtB;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB,EAAA;IAHpB;MAKG,gBAAgB;MAChB,eAAe;MACf,iBAAiB,EAAA;IAEnB;MACE,eAAe;MACf,oBAAoB,EAAA;MAFrB;QAIG,qBAAqB,EAAA;EAlB7B;IAuBI,gBAAgB;IAChB,aAAa;IACb,mBAAmB,EAAA;EAzBvB;IA4BI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,SAAS,EAAA;EAhCb;IAmCI,yBAAyB;IACzB,cAAc,EAAA;IApClB;MAsCM,yBAAyB;MACzB,cAAc,EAAA;EAvCpB;IA2CI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,eAAe;IACf,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,2BAA2B;IAC3B,kBAAkB;IAClB,UAAU;IACV,eAAe,EAAA;IAzDnB;MA2DM,WAAW;MACX,YAAY;MACZ,iBAAiB;MACjB,aAAa;MACb,WAAW;MACX,WAAW;MACX,kBAAkB;MAClB,+BAA4C;MAC5C,6BAA0C;MAC1C,yBAAyB,EAAA;IApE/B;MAuEM,mBAAmB;MACnB,2BAA2B,EAAA;EAG/B;IACE,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,eAAe,EAAA;IAVhB;MAYG,qBAAqB;MACrB,aAAa,EAAA","sourcesContent":[".wrapper {\n  width: 560px;\n  height: 625px;\n  padding: 20px;\n}\n.modal {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  &__header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    h2 {\n      font-weight: 600;\n      font-size: 24px;\n      line-height: 150%;\n    }\n    &_close {\n      cursor: pointer;\n      transition: all 0.4s;\n      &:hover {\n        transform: scale(1.1);\n      }\n    }\n  }\n  label {\n    margin-top: 30px;\n    display: flex;\n    align-items: center;\n  }\n  .buttons {\n    position: absolute;\n    bottom: 20px;\n    right: 20px;\n    display: flex;\n    gap: 10px;\n  }\n  .cancel {\n    background-color: #ffffff;\n    color: #fe6100;\n    &:hover {\n      background-color: #fe6100;\n      color: #ffffff;\n    }\n  }\n  .checkbox {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 0 16px 0 16px;\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    min-width: 20px;\n    width: 20px;\n    height: 20px;\n    background: white;\n    border: 1.5px solid #666666;\n    border-radius: 3px;\n    padding: 0;\n    cursor: pointer;\n    &:before {\n      content: '';\n      color: white;\n      font-weight: bold;\n      display: flex;\n      width: 13px;\n      height: 6px;\n      margin-bottom: 5px;\n      border-right: 1.5px solid rgb(255, 255, 255);\n      border-top: 1.5px solid rgb(255, 255, 255);\n      transform: rotate(135deg);\n    }\n    &:checked {\n      background: #fe6100;\n      border: 1.5px solid #fe6100;\n    }\n  }\n  &__input {\n    position: relative;\n    width: 100%;\n    padding: 8px 12px;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    border: 1px solid #9e9e9e;\n    border-radius: 4px;\n    display: flex;\n    margin-top: 6px;\n    &:focus {\n      border-color: #212121;\n      outline: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `modal_wrapper__aQdgs`,
	"modal": `modal_modal__ZEfWJ`,
	"modal__header": `modal_modal__header__r97wE`,
	"modal__header_close": `modal_modal__header_close__U2PK2`,
	"buttons": `modal_buttons__ibt4H`,
	"cancel": `modal_cancel__pweVF`,
	"checkbox": `modal_checkbox__mbFyT`,
	"modal__input": `modal_modal__input__+2Opk`
};
export default ___CSS_LOADER_EXPORT___;
